<div class="durl-page">
  <header class="durl-header">
    <div>
      <h1>
        <mat-icon>assignment_late</mat-icon>
        Solicitudes de actualización
      </h1>
      <p>Gestiona las solicitudes activas y crea nuevas para los clientes.</p>
    </div>
    <div style="display: inline-flex; gap: 8px; flex-wrap: wrap;">
      <button class="durl-btn durl-btn--ghost" (click)="goToBulkCreate()">
        <mat-icon>group_add</mat-icon> Solicitud masiva
      </button>
      <button class="durl-btn durl-btn--primary" (click)="openCreate()">
        <mat-icon>add</mat-icon> Nueva solicitud
      </button>
    </div>
  </header>

  <!-- KPIs -->
  <section class="durl-kpis">
    <div class="durl-kpi durl-kpi--pending">
      <mat-icon>pending_actions</mat-icon>
      <div>
        <span class="durl-kpi__num">{{ kpis.pendientes }}</span>
        <span class="durl-kpi__label">Pendientes</span>
      </div>
    </div>
    <div class="durl-kpi durl-kpi--expired">
      <mat-icon>schedule</mat-icon>
      <div>
        <span class="durl-kpi__num">{{ kpis.vencidas }}</span>
        <span class="durl-kpi__label">Vencidas</span>
      </div>
    </div>
    <div class="durl-kpi durl-kpi--review">
      <mat-icon>rate_review</mat-icon>
      <div>
        <span class="durl-kpi__num">{{ kpis.esperandoRevision }}</span>
        <span class="durl-kpi__label">Esperando revisión</span>
      </div>
    </div>
    <div class="durl-kpi durl-kpi--rejected">
      <mat-icon>cancel</mat-icon>
      <div>
        <span class="durl-kpi__num">{{ kpis.rechazadas }}</span>
        <span class="durl-kpi__label">Rechazadas</span>
      </div>
    </div>
    <div class="durl-kpi durl-kpi--done">
      <mat-icon>check_circle</mat-icon>
      <div>
        <span class="durl-kpi__num">{{ kpis.completadas }}</span>
        <span class="durl-kpi__label">Completadas</span>
      </div>
    </div>
    <div class="durl-kpi durl-kpi--risk">
      <mat-icon>warning</mat-icon>
      <div>
        <span class="durl-kpi__num">{{ kpis.reportadas }}</span>
        <span class="durl-kpi__label">Reportadas</span>
      </div>
    </div>
  </section>

  <!-- Filtros -->
  <section class="durl-filters">
    <input
      type="text"
      placeholder="Buscar por nombre, N° de documento o ID de usuario..."
      [(ngModel)]="filterQ"
      (keyup.enter)="applyFilters()"
      class="durl-input"
    />
    <select [(ngModel)]="filterEstado" (change)="applyFilters()" class="durl-input">
      <option value="">Todos los estados</option>
      <option value="PENDING">Pendientes</option>
      <option value="COMPLETED">Completadas</option>
      <option value="EXPIRED">Vencidas</option>
      <option value="CANCELLED">Canceladas</option>
      <option value="CLOSED_MAX_REJECTS">Cerradas (máx reintentos)</option>
    </select>
    <label class="durl-check">
      <input
        type="checkbox"
        [checked]="filterVencida === true"
        (change)="filterVencida = filterVencida === true ? null : true; applyFilters()"
      />
      Sólo vencidas
    </label>
    <label class="durl-check">
      <input
        type="checkbox"
        [checked]="filterRisk === true"
        (change)="filterRisk = filterRisk === true ? null : true; applyFilters()"
      />
      Sólo reportadas
    </label>
    <label class="durl-check durl-check--review">
      <input
        type="checkbox"
        [checked]="filterEnRevision"
        (change)="toggleEnRevision()"
      />
      Sólo con ítems por revisar
    </label>
    <button class="durl-btn durl-btn--ghost" (click)="applyFilters()">
      <mat-icon>search</mat-icon> Filtrar
    </button>
    <button class="durl-btn durl-btn--ghost" (click)="clearFilters()">
      Limpiar
    </button>
  </section>

  <!-- Tabla -->
  <section class="durl-table-wrap">
    <div *ngIf="loading" class="durl-loading">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Cargando solicitudes...</span>
    </div>

    <div *ngIf="errorMessage" class="durl-error">
      <mat-icon>error_outline</mat-icon>
      {{ errorMessage }}
      <button (click)="loadAll()">Reintentar</button>
    </div>

    <table *ngIf="!loading && !errorMessage && rows.length" class="durl-table">
      <thead>
        <tr>
          <th>Usuario</th>
          <th>N° ID</th>
          <th>Estado</th>
          <th>Items</th>
          <th>Por revisar</th>
          <th>Aging</th>
          <th>Riesgo</th>
          <th>Operador</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of rows"
          (click)="goToDetail(row)"
          class="durl-row"
          [class.durl-row--review]="hasItemsPendingReview(row)"
          [title]="hasItemsPendingReview(row) ? 'Tiene ítems por revisar — abrí para aprobar/rechazar' : ''"
        >
          <td>{{ usuarioLabel(row) }}</td>
          <td>{{ numeroIdLabel(row) }}</td>
          <td>
            <span
              class="durl-chip"
              [style.background]="estadoColor(row) + '22'"
              [style.color]="estadoColor(row)"
              [style.border-color]="estadoColor(row) + '55'"
            >
              {{ estadoLabel(row) }}
            </span>
          </td>
          <td>
            <span class="durl-items">
              <span class="durl-items__count" [title]="'Aprobados sobre total'">
                {{ itemsCountLabel(row) }}
              </span>
              <span
                *ngIf="sinEnviarOf(row) > 0"
                class="durl-items__pending"
                [title]="'Items que el cliente aún debe completar'"
              >
                +{{ sinEnviarOf(row) }} sin enviar
              </span>
              <span
                *ngIf="rechazadosOf(row) > 0"
                class="durl-items__rejected"
                [title]="'Items rechazados'"
              >
                {{ rechazadosOf(row) }} rechazados
              </span>
            </span>
          </td>
          <td>
            <span
              *ngIf="enRevisionCount(row) > 0"
              class="durl-review-badge"
              [title]="'Items enviados por el cliente esperando tu aprobación'"
            >
              <mat-icon>rate_review</mat-icon>
              {{ enRevisionCount(row) }}
            </span>
            <span *ngIf="enRevisionCount(row) === 0" class="durl-muted">—</span>
          </td>
          <td>
            <span class="durl-aging" [ngClass]="agingClass(row)">
              {{ agingLabel(row) }}
            </span>
          </td>
          <td>
            <mat-icon *ngIf="row.riskReported" style="color: #dc2626;">warning</mat-icon>
            <span *ngIf="!row.riskReported" class="durl-muted">—</span>
          </td>
          <td class="durl-muted">{{ createdByLabel(row) }}</td>
          <td>
            <button
              class="durl-btn-icon"
              (click)="$event.stopPropagation(); cancelRequest(row)"
              title="Cancelar solicitud"
              *ngIf="row.estado === 'PENDING'"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div *ngIf="!loading && !errorMessage && !rows.length" class="durl-empty">
      <mat-icon>inbox</mat-icon>
      <p *ngIf="!filterEnRevision">No hay solicitudes que coincidan con los filtros.</p>
      <p *ngIf="filterEnRevision">No hay solicitudes con ítems por revisar.</p>
    </div>
  </section>

  <!-- Paginación (el filtro "por revisar" ahora es server-side, así que
       pagina normal) -->
  <footer class="durl-pagination" *ngIf="rows.length">
    <button class="durl-btn durl-btn--ghost" (click)="prevPage()" [disabled]="page <= 1">
      <mat-icon>chevron_left</mat-icon> Anterior
    </button>
    <span>Página {{ page }} de {{ totalPages }} · {{ total }} resultados</span>
    <button class="durl-btn durl-btn--ghost" (click)="nextPage()" [disabled]="page >= totalPages">
      Siguiente <mat-icon>chevron_right</mat-icon>
    </button>
  </footer>
</div>
